/* =========================================================
   Interactions with safety checks for Shopify Theme Editor
   ========================================================= */
(function(){
  /* Guard: script is loaded from multiple SR sections — only run once */
  if(window.__srInitialized) return;
  window.__srInitialized = true;

  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  // ---- Image manifest loader --------------------------
  // For static HTML: reads assets/polomanor-images.json and injects <img>.
  // For Shopify: skip silently (images come from Liquid image_url).
  let MANIFEST = null;
  function applyImgFromManifest(el){
    if(!MANIFEST || !el) return;
    const slot = el.getAttribute('data-img');
    if(!slot) return;
    const entry = MANIFEST.slots && MANIFEST.slots[slot];
    const url = entry && entry.url;
    el.querySelectorAll('img.cdn').forEach(i=>i.remove());
    el.classList.remove('has-img');
    if(!url) return;
    const img = new Image();
    img.className = 'cdn';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = entry.alt || '';
    img.onload = () => { el.classList.add('has-img'); img.classList.add('loaded'); };
    img.onerror = () => { img.remove(); };
    img.src = url;
    el.appendChild(img);
  }
  function applyAllImages(){
    document.querySelectorAll('[data-img]').forEach(applyImgFromManifest);
  }
  // Only fetch manifest in static-HTML mode (relative path resolves). In Shopify the path won't exist → silent fail.
  if(!window.SRUSH_SHOPIFY){
    fetch('assets/polomanor-images.json', {cache:'no-store'})
      .then(r => r.ok ? r.json() : null)
      .then(j => { if(j){ MANIFEST = j; applyAllImages(); } })
      .catch(()=>{});
  }

  // ---- Lookbook image swap (Shopify-friendly) ----------
  // If lookData was pre-rendered by Liquid (window.SRUSH_LOOKS), use that;
  // otherwise the manifest path above handles it via data-img.
  function applyLookbookImage(L){
    if(!L || !lookImg) return;
    // Always clear previous image first
    lookImg.querySelectorAll('img.cdn').forEach(i=>i.remove());
    if(window.SRUSH_LOOKS && window.SRUSH_LOOKS[L.cat]){
      const url = window.SRUSH_LOOKS[L.cat];
      const img = new Image();
      img.className = 'cdn loaded';
      img.loading = 'lazy';
      img.alt = L.meta || '';
      img.src = url;
      lookImg.appendChild(img);
      lookImg.classList.add('has-img');
    } else {
      // No image for this look — show placeholder
      lookImg.classList.remove('has-img');
    }
  }

  // ---- Header scroll state -----------------------------
  const header = $('#header');
  const sticky = $('#stickycta');
  let stickyDismissed = false;
  
  let scrollTicking = false;
  const onScroll = () => {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      if (header) {
        header.classList.toggle('scrolled', window.scrollY > 40);
      }
      // sticky CTA after 25% scroll
      if (sticky) {
        const docH = document.documentElement.scrollHeight - window.innerHeight;
        const ratio = docH > 0 ? window.scrollY / docH : 0;
        if(!stickyDismissed && ratio > 0.25){
          sticky.classList.add('show');
        }
      }
      scrollTicking = false;
    });
  };
  window.addEventListener('scroll', onScroll, {passive:true});

  // ---- Mobile drawer -----------------------------------
  const drawer = $('#drawer');
  const menuOpen = $('#menuOpen');
  const menuClose = $('#menuClose');
  
  if (drawer && menuOpen) {
    menuOpen.addEventListener('click', ()=>{ 
      drawer.classList.add('open'); 
      drawer.setAttribute('aria-hidden','false'); 
      document.body.style.overflow='hidden'; 
    });
  }
  if (drawer && menuClose) {
    menuClose.addEventListener('click', closeDrawer);
  }
  $$('#drawer nav a').forEach(a=>a.addEventListener('click', closeDrawer));
  function closeDrawer(){ 
    if (drawer) {
      drawer.classList.remove('open'); 
      drawer.setAttribute('aria-hidden','true'); 
      document.body.style.overflow=''; 
    }
  }

  // ---- Editorial slider arrows -------------------------
  const ed = $('#editSlider');
  const edPrev = $('#edPrev');
  const edNext = $('#edNext');
  if (ed && edPrev && edNext) {
    const step = () => Math.round(ed.clientWidth * 0.7);
    edPrev.addEventListener('click', ()=> ed.scrollBy({left: -step(), behavior:'smooth'}));
    edNext.addEventListener('click', ()=> ed.scrollBy({left:  step(), behavior:'smooth'}));
  }

  // ---- Callout connector lines ----------------------------
  // Multi-instance safe (duplicate sections) + live redraw trong Theme Editor.
  function srDrawCallouts(stage){
    if (!stage) return;
    var svg = stage.querySelector('.callout-lines');
    if (!svg) return;
    svg.innerHTML = '';
    var sr = stage.getBoundingClientRect();
    if (!sr.width || !sr.height) return;
    var mob = window.innerWidth < 900;
    var ns = 'http://www.w3.org/2000/svg';
    stage.querySelectorAll('.callout[data-show-line="true"]').forEach(function(c){
      if (mob && c.dataset.hideM === 'true') return;
      var dot = c.querySelector('.dot');
      if (!dot) return;
      var dr = dot.getBoundingClientRect();
      var x1 = (dr.left + dr.width/2 - sr.left) / sr.width * 100;
      var y1 = (dr.top + dr.height/2 - sr.top) / sr.height * 100;
      var x2 = mob ? (+c.dataset.lineXM || +c.dataset.lineX || 50) : (+c.dataset.lineX || 50);
      var y2 = mob ? (+c.dataset.lineYM || +c.dataset.lineY || 50) : (+c.dataset.lineY || 50);
      var ln = document.createElementNS(ns, 'line');
      ln.setAttribute('x1', x1+'%'); ln.setAttribute('y1', y1+'%');
      ln.setAttribute('x2', x2+'%'); ln.setAttribute('y2', y2+'%');
      svg.appendChild(ln);
      var ci = document.createElementNS(ns, 'circle');
      ci.setAttribute('cx', x2+'%'); ci.setAttribute('cy', y2+'%');
      ci.setAttribute('r', '3');
      svg.appendChild(ci);
    });
  }
  function srInitCalloutStage(stage){
    if (!stage || stage.__srCallout) return;
    stage.__srCallout = true;
    var obs = new IntersectionObserver(function(e){
      if (e[0].isIntersecting){ requestAnimationFrame(function(){ srDrawCallouts(stage); }); obs.disconnect(); }
    }, {threshold:0.05});
    obs.observe(stage);
  }
  function srRedrawAllCallouts(){
    document.querySelectorAll('[data-callout-stage]').forEach(srDrawCallouts);
  }
  function srInitAllCallouts(root){
    (root || document).querySelectorAll('[data-callout-stage]').forEach(srInitCalloutStage);
  }
  srInitAllCallouts();

  // ---- Detail cards slider (lướt ngang + nút điều hướng) ----
  function srSliderUpdate(sl){
    var track = sl.querySelector('.sr-detail-track');
    var bar = sl.querySelector('.sr-detail-bar');
    var thumb = sl.querySelector('.sr-detail-bar__thumb');
    if (!track) return;
    var scrollable = track.scrollWidth > track.clientWidth + 4;
    if (bar) bar.hidden = !scrollable;
    if (thumb && scrollable){
      var w = Math.max(track.clientWidth / track.scrollWidth * 100, 10);
      var maxScroll = track.scrollWidth - track.clientWidth;
      var p = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      thumb.style.width = w + '%';
      thumb.style.left = (p * (100 - w)) + '%';
    }
  }
  function srInitDetailSlider(sl){
    if (!sl || sl.__srSlider) return;
    sl.__srSlider = true;
    var track = sl.querySelector('.sr-detail-track');
    if (!track) return;
    track.addEventListener('scroll', function(){ requestAnimationFrame(function(){ srSliderUpdate(sl); }); });
    srSliderUpdate(sl);
  }
  function srInitAllSliders(root){
    (root || document).querySelectorAll('[data-detail-slider]').forEach(srInitDetailSlider);
  }
  function srUpdateAllSliders(){
    document.querySelectorAll('[data-detail-slider]').forEach(srSliderUpdate);
  }
  srInitAllSliders();

  window.addEventListener('resize', function(){
    requestAnimationFrame(function(){ srRedrawAllCallouts(); srUpdateAllSliders(); });
  });

  // Theme Editor: re-init + redraw ngay khi đổi setting / chọn block (hết phải Save).
  if (window.Shopify && window.Shopify.designMode){
    ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect'].forEach(function(ev){
      document.addEventListener(ev, function(e){
        srInitAllCallouts(document);
        srInitAllSliders(document);
        requestAnimationFrame(function(){ srRedrawAllCallouts(); srUpdateAllSliders(); });
        setTimeout(function(){ srRedrawAllCallouts(); srUpdateAllSliders(); }, 150);
      });
    });
  }

  // ---- Palette swatch ---------------------------------
  const stage = $('#paletteStage');
  const swatches = $$('.swatch');
  if (stage && swatches.length > 0) {
    swatches.forEach(sw => {
      sw.addEventListener('click', ()=>{
        const c = sw.dataset.color;
        swatches.forEach(s => s.classList.toggle('active', s===sw));
        $$('.layer', stage).forEach(l => l.classList.toggle('active', l.dataset.color===c));
      });
    });
  }

  // ---- Lookbook ---------------------------------------
  const defaultLooks = [
    { cat:'smart',   slot:'lookbook_smart',   tags:['Pearl Linen Shirt','Tropical Trouser','Tan Loafer'], meta:'Look 01 · Smart Casual · Văn Phòng', ttl:'A monday<br/><em>done right.</em>',  tag:'PHOTO · Look 01 · Smart Casual', dark:false },
    { cat:'casual',  slot:'lookbook_casual',  tags:['Pima Polo Sand','Boardwalk Shorts','White Sneaker'], meta:'Look 02 · Casual · Weekend',         ttl:'Saturday,<br/><em>slow.</em>',          tag:'PHOTO · Look 02 · Casual Weekend',     dark:false },
    { cat:'travel',  slot:'lookbook_travel',  tags:['Capri Shirt Navy','Cooling Trouser','Leather Sandal'], meta:'Look 03 · Travel · Du Lịch',       ttl:'Light luggage,<br/><em>heavy taste.</em>', tag:'PHOTO · Look 03 · Travel Capsule',    dark:true  },
    { cat:'minimal', slot:'lookbook_minimal', tags:['Henley Ivory','Tropical Trouser','Tan Loafer'],     meta:'Look 04 · Minimal · Less is more',    ttl:'Three pieces,<br/><em>endless ways.</em>', tag:'PHOTO · Look 04 · Minimal Capsule', dark:false }
  ];
  
  const looks = window.SRUSH_LOOK_DATA && window.SRUSH_LOOK_DATA.length ? window.SRUSH_LOOK_DATA : defaultLooks;
  let lookIdx = 0;
  
  const lookImg = $('#lookImg');
  const lookTag = $('#lookTag');
  const lookTags = $('#lookTags');
  const lookMeta = $('#lookMeta');
  const lookTtl = $('#lookTtl');
  const lookIdxEl = $('#lookIdx');
  const lookBar = $('#lookBar');
  const lookPrev = $('#lookPrev');
  const lookNext = $('#lookNext');
  
  function renderLook(){
    if (!looks || looks.length === 0) return;
    const L = looks[lookIdx];
    if (!L) return;
    
    if (lookImg) {
      lookImg.classList.toggle('dark', L.dark);
      lookImg.setAttribute('data-img', L.slot);
      applyImgFromManifest(lookImg);
      applyLookbookImage(L);
    }
    if (lookTag) {
      lookTag.textContent = L.tag || `PHOTO · Look ${(lookIdx+1).toString().padStart(2,'0')}`;
      const hasImg = window.SRUSH_LOOKS && window.SRUSH_LOOKS[L.cat];
      lookTag.style.display = hasImg ? 'none' : '';
    }
    if (lookTags) lookTags.innerHTML = (L.tags || []).map(t=>`<span>${t}</span>`).join('');
    if (lookMeta) lookMeta.textContent = L.meta;
    if (lookTtl) lookTtl.innerHTML = L.ttl;
    if (lookIdxEl) lookIdxEl.textContent = String(lookIdx+1).padStart(2,'0') + ' / ' + String(looks.length).padStart(2,'0');
    if (lookBar) lookBar.style.width = ((lookIdx+1)/looks.length*100) + '%';
  }
  
  if (lookPrev) {
    lookPrev.addEventListener('click', ()=>{ 
      lookIdx = (lookIdx-1+looks.length)%looks.length; 
      renderLook(); 
    });
  }
  if (lookNext) {
    lookNext.addEventListener('click', ()=>{ 
      lookIdx = (lookIdx+1)%looks.length; 
      renderLook(); 
    });
  }
  
  $$('.filters button').forEach(b=>{
    b.addEventListener('click', ()=>{
      $$('.filters button').forEach(x=>x.classList.toggle('on', x===b));
      const f = b.dataset.look;
      if(f==='all'){ lookIdx = 0; renderLook(); return; }
      const i = looks.findIndex(l=>l.cat===f);
      if(i>=0){ lookIdx = i; renderLook(); }
    });
  });
  
  // Only render lookbook if looks and lookImg exists
  if (looks && looks.length > 0 && lookImg) {
    renderLook();
  }

  // ---- Sticky CTA --------------------------------------
  const stickyClose = $('#stickyClose');
  if (sticky && stickyClose) {
    stickyClose.addEventListener('click', ()=>{ 
      sticky.classList.remove('show'); 
      stickyDismissed = true; 
    });
  }

  // ---- Reveal on scroll -------------------------------
  const revealElements = $$('.reveal');
  if (revealElements.length > 0) {
    const io = new IntersectionObserver((ents)=>{
      ents.forEach(e=>{ 
        if(e.isIntersecting){ 
          e.target.classList.add('in'); 
          io.unobserve(e.target); 
        } 
      });
    }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    revealElements.forEach(el=>io.observe(el));
  }

  // ---- Read settings from header data attributes ----------
  var progressEnabled = header ? header.dataset.progress !== 'false' : true;
  var progressPos = header ? (header.dataset.progressPos || 'below') : 'below';
  var bttEnabled = header ? header.dataset.btt !== 'false' : true;
  var bttPos = header ? (header.dataset.bttPos || 'left') : 'left';

  // ---- #17 Scroll Progress Bar ----------------------------
  var progressBar = null;
  if(progressEnabled){
    progressBar = document.createElement('div');
    progressBar.className = 'sr-progress-bar pos-' + progressPos;
    progressBar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progressBar);
  }

  function updateProgress(){
    if(!progressBar) return;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    if(docH > 0){
      progressBar.style.width = (window.scrollY / docH * 100) + '%';
    }
    // Sync position with header scrolled state
    if(progressPos === 'below'){
      progressBar.classList.toggle('scrolled', window.scrollY > 40);
    }
  }

  // ---- #20 Back-to-Top Button ----------------------------
  var btt = null;
  if(bttEnabled){
    btt = document.createElement('button');
    btt.className = 'sr-btt pos-' + bttPos;
    btt.setAttribute('aria-label', 'Về đầu trang');
    btt.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btt);
    btt.addEventListener('click', function(){
      window.scrollTo({top:0, behavior:'smooth'});
    });
  }

  function updateBtt(){
    if(!btt) return;
    btt.classList.toggle('show', window.scrollY > window.innerHeight * 0.5);
  }

  // Patch onScroll to include progress + btt
  var onScrollAll = function(){
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function(){
      if (header) {
        header.classList.toggle('scrolled', window.scrollY > 40);
      }
      if (sticky) {
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        var ratio = docH > 0 ? window.scrollY / docH : 0;
        if(!stickyDismissed && ratio > 0.25){
          sticky.classList.add('show');
        }
      }
      updateProgress();
      updateBtt();
      scrollTicking = false;
    });
  };
  window.removeEventListener('scroll', onScroll);
  window.addEventListener('scroll', onScrollAll, {passive:true});

  // ---- #4 Cart Badge Dynamic Update ----------------------
  var lastCartCount = -1;
  function updateCartBadge(){
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(cart){
        var count = cart.item_count || 0;
        if(count === lastCartCount) return; // No change — skip DOM updates
        lastCartCount = count;
        document.querySelectorAll('items-count').forEach(function(el){
          el.textContent = count;
        });
        document.querySelectorAll('.sr-cart-link, .js-cart-icon').forEach(function(el){
          el.classList.toggle('has-items', count > 0);
        });
        // Bounce animation on update
        document.querySelectorAll('.sr-cart-count').forEach(function(badge){
          badge.style.transition = 'none';
          badge.style.transform = 'scale(1.4)';
          requestAnimationFrame(function(){
            badge.style.transition = 'opacity .25s, transform .25s';
            badge.style.transform = count > 0 ? 'scale(1)' : 'scale(0)';
          });
        });
      })
      .catch(function(){});
  }
  document.addEventListener('cart:updated', updateCartBadge);

  // Poll cart every 3s for third-party app changes (gift auto-add, etc.)
  // Only poll when tab is visible to save bandwidth
  var cartPollId = setInterval(function(){
    if(!document.hidden) updateCartBadge();
  }, 3000);

  // ---- #13 Animated Counter (Hero Stats) -----------------
  document.querySelectorAll('.sr-count[data-target]').forEach(function(el){
    var target = parseInt(el.dataset.target, 10);
    if(isNaN(target) || target <= 0) return;
    var done = false;
    var obs = new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting && !done){
        done = true;
        obs.disconnect();
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts){
          if(!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          // ease-out cubic
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if(progress < 1) requestAnimationFrame(step);
        }
        // Respect reduced-motion
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
          el.textContent = target;
        } else {
          el.textContent = '0';
          requestAnimationFrame(step);
        }
      }
    }, {threshold:0.3});
    obs.observe(el);
  });

  // initial paint
  onScrollAll();

  // ==========================================================
  // #3 QUICK SHOP MODULE
  // ==========================================================
  var srQuickShop = (function(){
    var el       = document.getElementById('srQuickShop');
    var closeBtn = document.getElementById('qsClose');
    var mainImg  = document.getElementById('qsMainImg');
    var thumbsEl = document.getElementById('qsThumbs');
    var titleEl  = document.getElementById('qsTitle');
    var priceEl  = document.getElementById('qsPrice');
    var descEl   = document.getElementById('qsDesc');
    var optsEl   = document.getElementById('qsOptions');
    var atcBtn   = document.getElementById('qsAtc');
    var linkEl   = document.getElementById('qsLink');
    var loadEl   = document.getElementById('qsLoading');
    var contEl   = document.getElementById('qsContent');

    if(!el) return {open:noop,close:noop};
    function noop(){}

    var product = null;
    var selOpts = {};
    var selVariant = null;

    function fmtMoney(cents){
      return new Intl.NumberFormat('vi-VN').format(Math.round(cents/100))+'₫';
    }
    function sizedImg(url,w){
      if(!url) return '';
      url = url.replace(/^\/\//,'https://');
      try{ var u=new URL(url); u.searchParams.set('width',w); return u.toString(); }
      catch(e){ return url+(url.indexOf('?')>-1?'&':'?')+'width='+w; }
    }

    /* ---- Open ---- */
    function open(productUrl, preColor){
      loadEl.style.display='';
      contEl.style.display='none';
      mainImg.innerHTML='';
      thumbsEl.innerHTML='';
      optsEl.innerHTML='';
      el.classList.add('open');
      el.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';

      var jsonUrl = productUrl;
      if(!jsonUrl.endsWith('.js')) jsonUrl+='.js';

      fetch(jsonUrl,{credentials:'same-origin'})
        .then(function(r){return r.json()})
        .then(function(p){
          product=p;
          render(p, preColor);
        })
        .catch(function(){
          close();
          window.location.href = productUrl;
        });
    }

    /* ---- Swatch color helper ---- */
    function guessColor(name){
      var map={
        'sand':'#D9C9A4','navy':'#1F2A44','white':'#FFFFFF','black':'#1a1a1a',
        'ivory':'#FFFFF0','olive':'#708238','charcoal':'#36454F','khaki':'#C3B091',
        'beige':'#F5F5DC','grey':'#808080','gray':'#808080','brown':'#8B4513',
        'tan':'#D2B48C','blue':'#4169E1','green':'#228B22','pink':'#FFB6C1',
        'red':'#DC143C','shady deep':'#3A6B6B','coastal mist':'#8EAAA4',
        'sunkissed tangerine':'#C4854A','golden dune':'#C9A96E',
        'bare sand':'#D6C8B5','shady poolside':'#A7C1D4',
        'kem':'#FFFFF0','trắng':'#fff','đen':'#1a1a1a','xám':'#808080',
        'nâu':'#8B4513','hồng':'#FFB6C1','xanh':'#4169E1',
        'xanh navy':'#1F2A44','xanh olive':'#708238',
        'be':'#F5F5DC','cát':'#D9C9A4'
      };
      var lo = (name||'').toLowerCase().trim();
      if(map[lo]) return map[lo];
      // hash fallback
      var h=0; for(var i=0;i<lo.length;i++) h=lo.charCodeAt(i)+((h<<5)-h);
      return 'hsl('+Math.abs(h)%360+',35%,62%)';
    }

    /* ---- Render product ---- */
    function render(p, preColor){
      /* Normalize: options may be strings OR objects from Shopify API */
      p.options = (p.options||[]).map(function(o){
        return typeof o === 'string' ? o : (o && o.name ? o.name : String(o));
      });
      /* Normalize: images may be strings OR objects */
      p.images = (p.images||[]).map(function(img){
        return typeof img === 'string' ? img : (img && img.src ? img.src : '');
      }).filter(Boolean);

      loadEl.style.display='none';
      contEl.style.display='';

      titleEl.textContent = p.title;
      linkEl.href = p.url || ('/products/'+p.handle);

      // Description
      if(p.body_html){
        var tmp=document.createElement('div');
        tmp.innerHTML=p.body_html;
        var txt=(tmp.textContent||tmp.innerText||'').trim();
        descEl.textContent = txt.substring(0,180)+(txt.length>180?'...':'');
        descEl.style.display = txt?'':'none';
      } else { descEl.style.display='none'; }

      // Gallery
      if(p.images && p.images.length>0){
        mainImg.innerHTML='<img src="'+sizedImg(p.images[0],800)+'" alt="'+p.title+'"/>';
        if(p.images.length>1){
          var th='';
          p.images.forEach(function(src,i){
            th+='<div class="qs-thumb'+(i===0?' active':'')+'" data-idx="'+i+'">';
            th+='<img src="'+sizedImg(src,120)+'" alt="" loading="lazy"/></div>';
          });
          thumbsEl.innerHTML=th;
        }
      } else {
        mainImg.innerHTML='<div style="padding:40px;color:var(--mid);text-align:center">No image</div>';
      }

      // Options
      selOpts={};
      optsEl.innerHTML='';

      if(p.variants.length===1 && p.variants[0].title==='Default Title'){
        selVariant = p.variants[0];
      } else {
        // Build option groups
        (p.options||[]).forEach(function(optName,oi){
          var vals=[]; var seen={};
          p.variants.forEach(function(v){
            var val=v['option'+(oi+1)];
            if(val && !seen[val]){ seen[val]=true; vals.push(val); }
          });

          var isColor = /color|colour|mau|màu/i.test(optName);
          var gh='<div class="qs-opt-group" data-oi="'+oi+'">';
          gh+='<div class="qs-opt-label">'+optName+' <span class="qs-sel"></span></div>';
          gh+='<div class="qs-opt-values">';

          vals.forEach(function(val,vi){
            var isPre = preColor && val.toLowerCase()===preColor.toLowerCase();
            var isDefault = (!preColor && vi===0) || isPre;

            if(isColor){
              /* Find variant image for this color */
              var colorVar = p.variants.filter(function(v){ return v['option'+(oi+1)]===val; })[0];
              var cImg = colorVar && colorVar.featured_image;
              var cImgSrc = cImg ? (typeof cImg==='string'?cImg:(cImg.src||'')) : '';
              gh+='<button class="qs-color-sw'+(isDefault?' active':'')+'" data-value="'+val+'" title="'+val+'">';
              if(cImgSrc){
                gh+='<img class="sw-img" src="'+sizedImg(cImgSrc,90)+'" alt="'+val+'"/>';
              } else {
                var bg = guessColor(val);
                gh+='<span class="sw-dot" style="background:'+bg+'"></span>';
              }
              gh+='</button>';
            } else {
              gh+='<button class="qs-size-btn'+(isDefault?' active':'')+'" data-value="'+val+'">'+val+'</button>';
            }
            if(isDefault) selOpts[oi]=val;
          });

          gh+='</div></div>';
          optsEl.innerHTML+=gh;

          if(!selOpts[oi] && vals.length) selOpts[oi]=vals[0];
        });
      }

      updateVariant();
      updatePrice();
    }

    /* ---- Variant matching ---- */
    function updateVariant(){
      if(!product) return;
      selVariant=null;
      product.variants.forEach(function(v){
        if(selVariant) return;
        var match=true;
        (product.options||[]).forEach(function(_,i){
          if(selOpts[i] && v['option'+(i+1)]!==selOpts[i]) match=false;
        });
        if(match) selVariant=v;
      });

      // Update availability per option value
      (product.options||[]).forEach(function(_,oi){
        var btns=optsEl.querySelectorAll('[data-oi="'+oi+'"] [data-value]');
        btns.forEach(function(btn){
          var val=btn.dataset.value;
          var avail=product.variants.some(function(v){
            if(v['option'+(oi+1)]!==val) return false;
            var ok=true;
            (product.options||[]).forEach(function(_,j){
              if(j!==oi && selOpts[j] && v['option'+(j+1)]!==selOpts[j]) ok=false;
            });
            return ok && v.available;
          });
          btn.classList.toggle('unavailable',!avail);
        });
        // Update selected label
        var span=optsEl.querySelector('[data-oi="'+oi+'"] .qs-sel');
        if(span) span.textContent = selOpts[oi]||'';
      });

      // Update image if variant has featured_image
      var featImg = selVariant && selVariant.featured_image;
      var featSrc = featImg ? (typeof featImg === 'string' ? featImg : featImg.src) : null;
      if(featSrc){
        var src=sizedImg(featSrc,800);
        var img=mainImg.querySelector('img');
        if(img && img.src!==src) img.src=src;

        // Highlight thumb
        if(product.images){
          var normFeat = featSrc.replace(/^https?:/,'').replace(/\?.*$/,'');
          product.images.forEach(function(iSrc,idx){
            var normI=iSrc.replace(/^https?:/,'').replace(/\?.*$/,'');
            if(normI===normFeat){
              thumbsEl.querySelectorAll('.qs-thumb').forEach(function(t,i){
                t.classList.toggle('active',i===idx);
              });
            }
          });
        }
      }

      // ATC state
      if(atcBtn){
        atcBtn.disabled = !selVariant || !selVariant.available;
        atcBtn.classList.remove('added','adding');
        atcBtn.textContent = (selVariant && selVariant.available) ? 'Thêm vào giỏ' : 'Hết hàng';
      }
    }

    function updatePrice(){
      if(!product||!priceEl) return;
      var v = selVariant || product.variants[0];
      if(!v) return;
      var h='';
      if(v.compare_at_price && v.compare_at_price>v.price){
        h+='<s>'+fmtMoney(v.compare_at_price)+'</s> ';
      }
      h+=fmtMoney(v.price);
      priceEl.innerHTML=h;
    }

    /* ---- Close ---- */
    function close(){
      el.classList.remove('open');
      el.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
      product=null; selVariant=null; selOpts={};
    }

    /* ---- Fly-to-cart animation ---- */
    function flyToCart(imgSrc){
      var cartIcon = document.querySelector('cart-link, .js-cart-icon');
      if(!cartIcon || !imgSrc) return;
      /* Respect prefers-reduced-motion */
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      var mainImgRect = mainImg.getBoundingClientRect();
      var cartRect = cartIcon.getBoundingClientRect();
      var fly = document.createElement('div');
      fly.className = 'sr-fly-cart';
      fly.innerHTML = '<img src="'+sizedImg(imgSrc,120)+'" alt=""/>';
      fly.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;'
        +'width:64px;height:80px;border-radius:6px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,.25);'
        +'left:'+mainImgRect.left+'px;top:'+mainImgRect.top+'px;'
        +'transition:all .65s cubic-bezier(.2,.8,.2,1);opacity:1;transform:scale(1);';
      fly.querySelector('img').style.cssText = 'width:100%;height:100%;object-fit:cover;';
      document.body.appendChild(fly);
      /* Force reflow then animate to cart icon */
      fly.offsetHeight;
      fly.style.left = (cartRect.left + cartRect.width/2 - 32)+'px';
      fly.style.top = (cartRect.top + cartRect.height/2 - 40)+'px';
      fly.style.transform = 'scale(.2)';
      fly.style.opacity = '0';
      fly.addEventListener('transitionend',function(){ fly.remove(); });
      setTimeout(function(){ fly.remove(); },1000); /* safety cleanup */
    }

    /* ---- Add to Cart ---- */
    function addToCart(){
      if(!selVariant||!selVariant.available) return;
      /* Prevent double-clicks */
      if(atcBtn.classList.contains('adding')) return;
      atcBtn.classList.add('adding');
      atcBtn.textContent='Đang thêm...';

      /* Capture image before close */
      var flyImgSrc = null;
      var curImg = mainImg.querySelector('img');
      if(curImg) flyImgSrc = curImg.src;

      /* Use theme's CartStore (Zustand) for proper state management */
      var cartStore = window.scaCart;
      if(cartStore && typeof cartStore.add === 'function'){
        cartStore.add({id: selVariant.id, quantity: 1})
          .then(function(){
            atcBtn.classList.remove('adding');
            atcBtn.classList.add('added');
            atcBtn.textContent='✓ Đã thêm';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            /* Fly-to-cart animation then close — no drawer auto-open */
            flyToCart(flyImgSrc);
            setTimeout(function(){
              close();
              cartStore.resetVariantsBeingAdded();
            },500);
          })
          .catch(function(err){
            atcBtn.classList.remove('adding');
            atcBtn.textContent='Lỗi — thử lại';
            setTimeout(function(){
              atcBtn.textContent='Thêm vào giỏ';
              atcBtn.disabled=false;
            },2000);
          });
      } else {
        /* Fallback: raw fetch if CartStore unavailable */
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:selVariant.id,quantity:1}]})
        })
        .then(function(r){return r.json()})
        .then(function(){
          atcBtn.classList.remove('adding');
          atcBtn.classList.add('added');
          atcBtn.textContent='✓ Đã thêm';
          lastCartCount = -1;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          flyToCart(flyImgSrc);
          setTimeout(function(){ close(); },500);
        })
        .catch(function(){
          atcBtn.classList.remove('adding');
          atcBtn.textContent='Lỗi — thử lại';
          setTimeout(function(){
            atcBtn.textContent='Thêm vào giỏ';
            atcBtn.disabled=false;
          },2000);
        });
      }
    }

    /* ---- Event Delegation ---- */
    // Option clicks
    optsEl.addEventListener('click',function(e){
      var btn=e.target.closest('[data-value]');
      if(!btn||btn.classList.contains('unavailable')) return;
      var grp=btn.closest('.qs-opt-group');
      if(!grp) return;
      var oi=parseInt(grp.dataset.oi);
      grp.querySelectorAll('[data-value]').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      selOpts[oi]=btn.dataset.value;
      updateVariant();
      updatePrice();
    });

    // Thumbnail clicks
    thumbsEl.addEventListener('click',function(e){
      var t=e.target.closest('.qs-thumb');
      if(!t||!product) return;
      var idx=parseInt(t.dataset.idx);
      var src=product.images[idx];
      if(!src) return;
      var img=mainImg.querySelector('img');
      if(img) img.src=sizedImg(src,800);
      thumbsEl.querySelectorAll('.qs-thumb').forEach(function(th,i){th.classList.toggle('active',i===idx)});
    });

    // ATC
    if(atcBtn) atcBtn.addEventListener('click',addToCart);

    // Close
    if(closeBtn) closeBtn.addEventListener('click',close);

    // Click outside inner
    el.addEventListener('click',function(e){ if(e.target===el) close(); });

    return {open:open,close:close};
  })();

  // ==========================================================
  // KEYBOARD: Escape closes Quick Shop
  // ==========================================================
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      var qsEl=document.getElementById('srQuickShop');
      if(qsEl && qsEl.classList.contains('open')) srQuickShop.close();
    }
  });

  // ==========================================================
  // INTEGRATIONS
  // ==========================================================

  /* ---- quickshop:open event → opens Quick Shop ---- */
  document.addEventListener('quickshop:open',function(e){
    if(e.detail && e.detail.url){
      srQuickShop.open(e.detail.url, e.detail.color||null);
    }
  });

})();

